module.exports = __webpack_public_path__ + "static/media/Dragonair_gaussian2.4eaa6199.png";